<template>
  <transition name="fade-in" mode="out-in">
    <div
      tabindex="-1"
      class="fp-registration-progress-tooltip-container"
      :class="{'shorter' : !stepNumber}"
    >
      <span v-show="stepNumber">Step {{ stepNumber }}: </span><span>{{ text }}.</span>

      <slot />
    </div>
  </transition>
</template>

<script>
  export default {
    name: "FPRegistrationProgressTooltip",
    props: {
      stepNumber: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
    },
    methods: {

    }
  }
</script>
